import { Callout } from './callout';

export class PageConfiguration {
    ID: number;
    Guid: string;
    CountryID: number;
    PartnerCodes: string;
    PartnerCodeSelectText: string;
    PartnerCodeSelectValidationText: string;
    Name: string;
    Alias: string;
    Format: string;
    BillboardFormat: string;
    Image: string;
    ImageMobile: string;
    ImagePreHeadLine: string;
    ImageHeadLine: string;
    ImageDescription: string;
    HeaderTitleText: string;
    CorporationLogo: string;
    CorporationLogoText: string;
    LogoText: string;
    Logo: string;
    EnableRegistration: boolean;
    TermsText: string;
    TermsUrl: string;
    RegistrationInfo: string;
    AdditionalFieldsFormID: number;
    SuccessMessage: string;
    ShowVehicles: boolean;
    SpecialOfferRequestInformation: string;
    PinRequireApproval: boolean;
    PinApprovalEmailsToNotify: string;
    EnablePinOverrides: boolean;
    ProgramVisibility: number;
    PinPrefix: string;
    PinEmail: string;
    PinTemplate: string;
    ProgramType: Array<any>;
    PinExpiration: number;
    PinExpirationDays: number;
    PinExpirationDate: string;
    Billboard_Copy: string;
    BillboardContentAlignment: string;
    VideoUrl: string;
    ShareCallout: boolean;
    Callout: Array<Callout>;
    Legal: string;
    CreateUser: boolean;
    UserRequireApproval: boolean;
    UserRoles: string;
    BackgroundVideoUrl: string;
    VideoPreHeadLine: string;
    VideoHeadLine: string;
    sVideoDescription: string;
    Video1Url: string;
    Image1: string;
    Video1Text: string;
    Video2Url: string;
    Image2: string;
    Video2Text: string;
    Video3Url: string;
    Image3: string;
    Video3Text: string;
    ShareForm: string;
    PromotionOfferDetails: string;
    PromotionOfferDetailsSidebar: string;
    PromotionPreferredContactText: string;
    PromotionHidePrefContact: boolean;
    PromotionShowDriversLicense: boolean;
    UseIdMe: boolean;
    PromotionIDmeLogo: string;
    PromotionIDmeText: string;
    PromotionIDmeText2: string;
    PromotionIDmeLearnMore: string;
    PromotionWhatIsIDme: string;
    PromotionFAQ: string;
    PromotionFAQButtonLabel: string;
    AllowSponoredPIN: boolean;
    SponsoredPinRegistrationPartnerCodes: string;
    SponsoredPinRegistrationHeadline: string;
    SponsoredPinRegistrationInfo: string;
    SponsoredPinRegistrationCalloutHeadline: string;
    SponsoredPinRegistrationCalloutText: string;
    SponsoredPinRegistrationCalloutImage: string;
    SponsoredPinRegistrationCalloutLabel: string;
    SponsoredPinRegistrationTermsText: string;
    PinRegistrationFooterText: string;
    PageTitle: string;
    // PageDescription: string;
    // PageMetaImg: string = "https://aplanbyvolvo.azureedge.net/media/av/media/aplan/social/2021-volvo-meta-image.jpg";
}
